import React, { Component } from 'react';
import { Button, Spin, Table, notification, Col, Row, Modal, message, Icon } from 'antd';
import moment from 'moment';
import _AdminService from 'modules/AdminService';
import DropdownList from 'components/controls/DropdownList';
import { ROOT_PATH } from '../../constants/constants';
import PageHeader from 'components/enterprise/PageHeader';
import { routesAdmin } from 'routes/Routes';
import ConfirmPopup from '../popup/ConfirmPopup';


class ViewCenterBatchData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      centerList: [],
      Data: [], // Ensure this is an array to pass into the Table component
      selectedCenter: null,
      loading: false,
      totalCount: 0,
      showDeleteConfirm: false,
    };
  }

  componentDidMount() {
    this.fetchCenters();
  }

  // Converts an array into objects with Id and Name keys for dropdown options.
  transformArray = (responseArray) => {
    return responseArray.map((item) => ({
      Id: item,
      Name: item,
    }));
  };

  // Fetch centers when the page loads
  fetchCenters = async () => {
    this.setState({ loading: true, centerList: [], Data: [], selectedCenter: null });
    try {
      const response = await _AdminService.GetAllCenterBatchList();   // Assuming API returns data in response.data
      this.setState({ centerList: this.transformArray(response.data), loading: false });
    } catch (error) {
      this.setState({ loading: false });
      //notification.error({ message: 'Error fetching centers', description: error.message });
    }
  };

  // handleCenterChange = async (event) => {

  //   this.setState({ selectedCenter: event.target.value, loading: true });
  //   try {
  //     // Fetch batches based on selected center
  //     const response = await _AdminService.GetAllCenterBatchDataByCenter(event.target.value);

  //     // Check if the response contains data in the expected format
  //     if (response.data && response.data) {
  //       this.setState({ Data: response.data, loading: false });
  //     }

  //   } catch (error) {
  //     this.setState({ loading: false });
  //     //notification.error({ message: 'Error fetching batches', description: error.message });
  //   }
  // };

  handleCenterChange = async (event) => {
    const selectedCenter = event.target.value;

    // If the selected value is "Select Center" (placeholder), clear data and stop fetching
    if (selectedCenter === "Select Center" || selectedCenter === "") {
      this.setState({ selectedCenter, Data: [], totalCount: 0, loading: false });
      return;
    }

    this.setState({ selectedCenter, loading: true });
    try {
      // Fetch batches based on selected center
      const response = await _AdminService.GetAllCenterBatchDataByCenter(event.target.value);

      // Check if the response contains data in the expected format
      if (response.data) {
        this.setState({ Data: response.data, totalCount: response.data.length, loading: false });
      }

    } catch (error) {
      this.setState({ loading: false });
      // notification.error({ message: 'Error fetching batches', description: error.message });
    }
  };


  onViewClick = async (record) => {
    try {
      this.setState({ isLoading: true });

      // Fetch student data for attendance based on Start and End Roll Numbers
      const response = await _AdminService.GetStudentDataForAttendance(record.StartRoleNumber, record.EndRoleNumber);
      console.log(response);

      // Check if the response contains valid data
      const candidates = response.data.Obj;

      if (candidates && candidates.length > 0) {
        // Map through the candidates and create the full name and add the necessary fields
        const updatedCandidates = candidates.map((candidate) => ({
          ...candidate,
          candidateSignature: "",  // Initial empty signature
          candidateName: `${candidate.Firstname || ''} ${candidate.MiddleName || ''} ${candidate.LastName || ''}`.trim(),
        }));

        // Update state with the chunked candidate data and set other properties
        this.setState({
          isLoading: false,
        });
      }
    } catch (e) {
      console.error("Error:", e);
      this.setState({ isLoading: false });
      notification.error({
        message: 'Error',
        description: 'There was an error fetching the candidate data.',
      });
    }
  };

  deleteCenterBatchData = async () => {
    this.setState({ loading: true });
    try {
      const response = await _AdminService.DeleteCenterBatchData();
      if (response.data.IsSuccess) {
        this.setState({
          centerList: [],
          Data: [],
          selectedCenter: null,
          loading: false,
        });

      } else {
        this.setState({ loading: false });
        message.error("Failed to delete center batch data.");
      }
    } catch (error) {
      this.setState({ loading: false });
      message.error("Failed to delete center batch data.");
      console.error('Error deleting center batch data:', error);
    }
  };

  handleDeleteConfirmation = () => {
    this.setState({ showDeleteConfirm: true });
  };

  render() {
    const { centerList, Data, loading } = this.state;

    const TableColumns = [
      // {
      //   title: 'ID',
      //   dataIndex: 'Id',
      //   key: 'Id',
      //   width: '4%',
      //   sorter: (a, b) => a.Id - b.Id,
      // },
      {
        title: 'Center',
        dataIndex: 'Center',
        key: 'Center',
        width: '5%',
        filterSearch: true,
        sorter: (a, b) => a.Center.localeCompare(b.Center),
      },
      {
        title: 'Batch',
        dataIndex: 'Batch',
        key: 'Batch',
        width: '5%',
        filterSearch: true,
        sorter: (a, b) => a.Batch.localeCompare(b.Batch),
      },
      {
        title: 'Batch Name',
        dataIndex: 'BatchName',
        key: 'BatchName',
        width: '10%',
        filterSearch: true,
        sorter: (a, b) => a.BatchName.localeCompare(b.BatchName),
      },
      {
        title: 'Batch Time',
        dataIndex: 'BatchTime',
        key: 'BatchTime',
        width: '10%',
        filterSearch: true,
        sorter: (a, b) => a.BatchTime.localeCompare(b.BatchTime),
      },
      {
        title: 'Start Roll Number',
        dataIndex: 'StartRoleNumber',
        key: 'StartRoleNumber',
        width: '8%',
        sorter: (a, b) => a.StartRoleNumber - b.StartRoleNumber,
      },
      {
        title: 'End Roll Number',
        dataIndex: 'EndRoleNumber',
        key: 'EndRoleNumber',
        width: '8%',
        sorter: (a, b) => a.EndRoleNumber - b.EndRoleNumber,
      },
      {
        title: 'Count',
        dataIndex: 'Count',
        key: 'Count',
        width: '5%',
        render: (text, record) =>
          record.EndRoleNumber && record.StartRoleNumber
            ? record.EndRoleNumber - record.StartRoleNumber + 1
            : 0,
      },
      {
        title: 'Exam Date',
        dataIndex: 'ExamDate',
        key: 'ExamDate',
        width: '6%',
        render: (text, record) =>
          moment(record.ExamDate).isValid()
            ? moment(record.ExamDate).format('DD-MMM-YYYY')
            : '',
        sorter: (a, b) => moment(a.ExamDate).unix() - moment(b.ExamDate).unix(),
      },
      {
        title: 'Post',
        dataIndex: 'Post',
        key: 'Post',
        width: '5%',
        filterSearch: true,
        sorter: (a, b) => a.Post.localeCompare(b.Post),
      },
      {
        title: 'Center Name',
        dataIndex: 'CenterName',
        key: 'CenterName',
        width: '5%',
        filterSearch: true,
        sorter: (a, b) => a.CenterName.localeCompare(b.CenterName),
      },
    ];

    return (
      <Spin spinning={loading}>
        <div className="container-fluid p-3">
          <PageHeader
            title="View Center Batch Data"
            breadcrumbItems={[{ label: 'Dashboard', path: routesAdmin.dashboard.path }, { label: 'Attendance' }, { label: 'View Center Batch Data' }]}
          />
          <div className="ent-panel mb-3">
            <Row gutter={16} className="m-0 d-flex align-items-center">
              <Col span={4} className="d-flex align-items-center">
                <label htmlFor="center" className="mb-0 mr-2">Center:</label>
                <DropdownList
                  wrapClass="w-100 mb-0"
                  id="center" // Ensures the ID is associated with the label
                  placeholder="Select Center"
                  options={centerList}
                  onChange={this.handleCenterChange}
                  value={this.state.selectedCenter}
                  name="Center"
                />
              </Col>

              <Col span={6} style={{ marginLeft: "25px", fontWeight: "bold" }}>
                Total Records : {this.state.totalCount}
              </Col>

              <Col span={13} className="d-flex align-items-center justify-content-end pr-0">
                <a
                  type="primary"
                  danger
                  className="button-global button-border removebutton addbutton autoWidth d-inline-block text-center autoHeight"
                  onClick={this.handleDeleteConfirmation}
                >   <Icon type="delete" className="mr-2 align-middle mb-1" />
                  Delete Center Batch Data
                </a>
              </Col>
            </Row>
            <div className="mt-3">
              <Table
                size="small"
                columns={TableColumns}
                dataSource={this.state.Data}
                rowKey="Id"
                pagination={false}
                className="table-striped-rows admin-table"
              />
            </div>
          </div>
        </div>
        <Modal
          footer={false}
          onCancel={() => this.setState({ showDeleteConfirm: false })}
          visible={this.state.showDeleteConfirm}
          className="modelPopAnt admin-home"
        >
          <ConfirmPopup
            message="Are you sure? Do you want to delete the Center batch data?"
            onCancel={() => {
              console.log("Operation canceled.");
              this.setState({ showDeleteConfirm: false });
            }}
            onOk={() => {
              this.setState({ showDeleteConfirm: false });
              return new Promise((resolve, reject) => {
                this.deleteCenterBatchData()
                  .then(() => {
                    message.success("Center batch data deleted successfully!");
                    resolve();
                  })
                  .catch((error) => {
                    message.error("Failed to delete center batch data.");
                    console.error("Failed to delete center batch data:", error);
                    reject();
                  });
              });
            }}
          />
        </Modal>
      </Spin>
    );
  }
}

export default ViewCenterBatchData;



